var map = {
	"./cookie_checker.svg": 45771,
	"./cookie_consent.svg": 89768,
	"./cookie_consent_banner.svg": 51405,
	"./cookie_consent_hero.svg": 67939,
	"./cookie_policy.svg": 99944,
	"./cookie_policy_hero.svg": 67459,
	"./customer_service_policy.svg": 49122,
	"./disclaimer.svg": 9268,
	"./eula.svg": 30490,
	"./eula_hero.svg": 90749,
	"./general-policy.svg": 86962,
	"./privacy_policy.svg": 78440,
	"./privacy_policy_hero.svg": 40355,
	"./refund_policy.svg": 61212,
	"./refund_policy_hero.svg": 99639,
	"./shipping_policy.svg": 77464,
	"./terms_of_service_hero.svg": 54021,
	"./tos.svg": 22165,
	"./website_scan.svg": 32624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13045;